import Creatable from "react-select/creatable";
import { Option } from "./Options";
import {
  _classNames,
  _components,
  _filterOption,
  _formatCreateLabel,
  OPTIONS,
  Options
} from "./constant";

interface ICreatableDropdownSelect
  extends Omit<React.ComponentProps<typeof Creatable>, "onChange"> {
  _options?: Options;
  onChange?: (opt: Option) => void; // To fix the annoying unknown type on the default onChange signature
  controlClassName?: string;
  _createLabel?: keyof typeof _formatCreateLabel;
}

// This component behaves like a dropdown select but allows to create new options
const CreatableDropdownSelect = ({
  className,
  _options,
  _createLabel,
  onChange,
  classNames,
  value,
  ...props
}: ICreatableDropdownSelect) => {
  if (_options) props.options = OPTIONS[_options];
  if (_createLabel) props.formatCreateLabel = _formatCreateLabel[_createLabel];
  // React-select does not handle undefined properly
  if (value === undefined) value = null;

  return (
    <div className={className}>
      <Creatable
        classNames={{
          ..._classNames(props),
          ...classNames
        }}
        filterOption={_filterOption}
        components={_components}
        hideSelectedOptions={false}
        createOptionPosition="first"
        value={value}
        {...props}
        onChange={onChange as any}
      />
    </div>
  );
};

export default CreatableDropdownSelect;
